import DefaultErrorPage from './DefaultErrorPage';

export default DefaultErrorPage;
